/**
 * Today on the business calendar: the America/New_York day as YYYY-MM-DD, whatever zone the
 * browser is in. The API refuses a visit date after this same day (clocks.floridaDay), so the
 * date picker's upper bound must be computed the same way.
 */
const FORMAT = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' });

// Built from the parts, not from a locale's idea of how a date is written.
export const floridaToday = (now: Date = new Date()): string => {
  const part = (type: string) => FORMAT.formatToParts(now).find((p) => p.type === type)?.value || '';
  return `${part('year')}-${part('month')}-${part('day')}`;
};
